import React from 'react';
import Picker from './Picker';

const TimesheetFilters = ({ filterProjectId, filterTasks, filters, onChange, projects, t, theme, view }) => (
  <div className="timesheets-filters">
    <Picker
      id="filter-projects"
      name="project"
      label={t('project') || 'Project'}
      placeholder={t('allProjects') || 'All Projects'}
      options={projects}
      value={filters.project}
      onChange={onChange}
      theme={theme}
    />

    <Picker
      id="filter-tasks"
      name="task"
      label={t('task') || 'Task'}
      placeholder={t('allTasks') || 'All Tasks'}
      options={filterTasks}
      value={filters.task}
      onChange={onChange}
      disabled={!filterProjectId && filterTasks.length === 0}
      theme={theme}
    />

    {view === 'list' && (
      <>
        <label className="timesheets-field">
          <span>{t('dateFrom') || 'Date From'}</span>
          <input
            type="date"
            name="dateFrom"
            value={filters.dateFrom}
            max={filters.dateTo || undefined}
            onChange={onChange}
            style={{ borderColor: theme.border, color: theme.text }}
          />
        </label>

        <label className="timesheets-field">
          <span>{t('dateTo') || 'Date To'}</span>
          <input
            type="date"
            name="dateTo"
            value={filters.dateTo}
            min={filters.dateFrom || undefined}
            onChange={onChange}
            style={{ borderColor: theme.border, color: theme.text }}
          />
        </label>
      </>
    )}
  </div>
);

export default TimesheetFilters;
